import React from 'react';
import Submenu from './Submenu';
import { getProductUrl } from '../../../utils/urls/productUrls.js';
import { favoritesMangerPath } from '../../../utils/favorites';

import config from '../../../config';
import { signInUrl } from '../../../utils/urls/signInUrl';
import Button, { TYPE } from '../../Button/Button';

class FavoritesMenu extends Submenu {
  static propTypes = {
    user: React.PropTypes.object.isRequired,
    doTrackEvent: React.PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.config = config;
    this.favorites = props.favorites || this.props.user.favorites || [];
    this.userType = props.user.type || 'non-registered';
    this.analytics = this.props.analytics;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.favorites) {
      this.favorites = nextProps.favorites;
    }
  }

  clickedFavorite = (link, name, point) => {
    const { doTrackEvent } = this.props;

    doTrackEvent('Clicked View Forecast', {
      favoriteName: name,
      lat: point[1],
      lon: point[0],
      location: 'favorites',
    });
  }

  clickedTryPremium = () => {
    window.location.href = this.config.links.funnel.registerNow;
  }

  clickedSignIn = () => {
    const { pathname, search, hash } = window.location;
    window.location.href = signInUrl(
      this.config.links.funnel.login,
      `${pathname}${search}${hash}`,
      this.config.useNewWebCharts,
    );
  }

  clickedRenew = () => {}

  render() {
    const navClasses = super.getMenuClasses('favoritesMenu');
    if (this.favorites.length > 0 || this.userType !== 'non-registered') {
      return (
        <ul className={navClasses} id="favoritesMenu">
          <li className="header">Your Favorites</li>

          {(() => { // user with no favorites
            if (this.favorites.length === 0) {
              return (
                <div>
                  <li className="touch" style={{ marginBottom: '15px' }}>
                    Pick a point and view a<br /> forecast to save a favorite
                  </li>
                  <li className="desktop info">
                    <div style={{ margin: '10px' }}>
                      Pick a point and view a forecast to save a favorite
                    </div>
                  </li>
                </div>
              );
            }
          })()}

          { // user with favorites
            this.favorites.map((favorite, index) => {
              const hidden = (index > 49) ? 'touch' : '';
              return (
                <li key={index} className={`default ${hidden}`}>
                  <a
                    onClick={this.clickedFavorite.bind(this, getProductUrl(favorite), favorite.name, favorite.point)}
                    href={getProductUrl(favorite)}
                  >
                    {favorite.name}
                  </a>
                </li>
              );
            })
          }

          {(() => { // user with too many favorites
            if (this.favorites.length > 50) {
              return (
                <div>
                  <li className="desktop info">
                    <a
                      href={favoritesMangerPath}
                      className="favorites-btn"
                    >
                      View all favorites
                    </a>
                  </li>
                </div>
              );
            }
          })()}
        </ul>
      );
    }
    return (
      <ul className={navClasses} id="favoritesMenu">

        {(() => { // non registered
          if (this.userType === 'non-registered') {
            return (
              <div>
                <li className="header">Favorites</li>
                <li className="touch" style={{ marginBottom: '15px' }}>Register to begin<br /> saving favorites.</li>
                <li className="touch">
                  <Button
                    onClick={this.clickedTryPremium}
                    type={TYPE.premium}
                    className="favorites-btn"
                  >
                    Register Now
                  </Button>
                </li>
              </div>
            );
          }
        })()}

        {(() => { // non-registered user who needs to login
          if (this.userType === 'non-registered') {
            return (
              <div>
                <li className="divider"><span>or</span></li>
                <li className="touch" style={{ marginBottom: '15px' }}>Sign in to access<br /> existing favorites</li>
                <li>
                  <Button
                    onClick={this.clickedSignIn}
                    className="favorites-btn"
                  >
                    Sign In
                  </Button>
                </li>
              </div>
            );
          }
        })()}

        {(() => { // non-registered / registered users on the desktop.
          if (this.userType === 'non-registered') {
            return (
              <li className="desktop info">
                <div style={{ margin: '10px' }}>
                  Try Premium to begin saving favorites.
                </div>
              </li>
            );
          }
        })()}

      </ul>
    );
  }
}

export default FavoritesMenu;



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/menus/FavoritesMenu.js